export const DEFAULT_REACTIONS = ['2764-fe0f', '1f44d', '1f647-200d-2642-fe0f', '1f64c'];
